<template>
    <div class="w-100">
      <listado-clientes-extra-cost />
    </div>
  </template>
  
  <script>
  
    // Vuex
    import { mapActions } from "vuex";
  import ListadoClientesExtraCost from '../../../components/tablas/tarifas/ListadoClientesExtraCost.vue';
  
    export default {
      
      components: {ListadoClientesExtraCost  },
  
      methods: {
  
        // Acciones de Vuex
        ...mapActions(["AccionCambiar"]),
      
  
        // Función para actualizar url en state
        actualizarURL() {
          let me = this;
          me.AccionCambiar(this.$route.path);
        }
  
      },
  
        created() {
        // Ejecución de actualizarURL una vez que se carga el componente
        this.actualizarURL();
      },
  
    }
  </script>
  
  
  <style>
  
  </style>